import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import '@fontsource-variable/source-sans-3'
import './styles/global.css'
import { installSiteLoginRedirect } from './lib/siteLogin'
import { followSystemTheme } from './lib/theme'

// Welche Fassung läuft hier gerade? Beim Einrichten war das mehrfach die
// entscheidende Frage — ein neuer Stand war deployt, der Browser lieferte den
// alten, und die Fehlersuche lief auf Code, der gar nicht lief.
console.warn(`K4ia — ${__K4IA_VERSION__}, Build ${__K4IA_BUILD__}`)

// Nur in der Testumgebung wirksam: abgelaufene Anmeldung → Anmeldeseite.
installSiteLoginRedirect()

// Hell oder dunkel wie das System — bis der Besucher den Schalter tippt.
followSystemTheme()

const container = document.getElementById('root')
if (!container) throw new Error('Root element #root not found')

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
